import { handleApiResponse } from '../utils/apiUtils';
import secureApi from './secureApi';

export const getWeeklyRanking = (limit = 10) =>
  handleApiResponse(() => secureApi.get(`/user/ranking/weekly?limit=${limit}`));
